module.exports = __webpack_public_path__ + "static/media/logo5.614ba31f.svg";